angular.module('natgeo').controller('Level2BuildScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ColorizeFactory', 'UserProgress', 'CommonFunctions', 'ScreenView',
function Level2BuildScreen($scope, element, ScreenFactory, manager, container, ColorizeFactory, UserProgress, CommonFunctions, ScreenView)
{
	var screen = ScreenFactory( 'level2_build', element );

	// Store the current state so it can be restored later.
	screen.store();

	// How many times the screen has reloaded
	screen.loads = 0;
	
	// The sub-states for this screen (one for each time we need to hit the next button)
	var States = {
		Building: 1,
		Coloring: 2,
		PowerItUp: 3,
		TestPreview: 4
	};

	// Before the screen is loaded
	screen.on('introBefore', function()
	{
		if ( screen.loads > 0 )
		{
			// Restore screen to initial values
			screen.restore( ScreenView, container, $scope );
		}

		// The current screen state
		screen.state = States.Building;

		// The number of sucessful drops
		screen.dropCount = 0;
		screen.dropMax = 7;

		// Initialize the draggable components
		CommonFunctions.initializeDraggable( screen );
		
		// Initialize the droppable areas
		CommonFunctions.initializeDroppable( screen );

		// Sets the helper text
		screen.setHelperText = CommonFunctions.setHelperText( screen._helperText, screen._helperBox );

		// Loaded!
		screen.loads++;
	});

	// When the screen is first loaded by the manager.
	screen.once('introBefore', function()
	{
		// Animations used on the screen
		anim8.save('planFadePartial', {
			keyframe: {
				from: {
					opacity: 1
				},
				to: {
					opacity: 0.6
				}
			}
		});
		
		anim8.save('bodyGroupTest', {
			keyframe: {
				from: {
					scale: 1,
					translate: 0
				},
				to: {
					scale: 0.7,
					translate: {x:55, y:-55} 
				}
			},
			units: {
				translate: '%'
			}
		});
	});
	
	// When a part is successfully dropped on the correct body section.
	screen.onPartDrop = function(part)
	{
		screen._bodyGroup
			.find('.' + part.data('named'))
			.removeClass('hidden')
			.play('fadeIn 0.5s')
		;
		
		part
			.hide()
			.parent()
			.play('fadeOut 0.5s')
			.animators()
			.once('finished', function(animator) {
				part.parent().remove();
			})
		;

		screen.setHelperText('Good job!');
	};
	
	// When the last part has been placed on the body.
	screen.onLastPart = function()
	{
		screen.outroduce( 'description', 'fadeOut', function()
		{
			screen.introduce( 'completed', 'flipInX' );
			screen.introduce( 'next', 'nextIn ~1s' );
			screen.introduce( 'shadow', 'fadeIn' );
			screen.introduce( 'bodyNoLabel', 'fadeIn' );
			screen.outroduce( 'body', 'fadeOut ~1s' );
		});

		screen.setHelperText('Way to go!');
	};

	// Hides & Shows Next
	screen.toggleNext = function()
	{
		screen.outroduce( 'next', 'nextOut', function()
		{
			screen.introduce( 'next', 'nextIn ~1');
		});
	};
	
	// Initializes the coloring screen
	screen.setColoringState = function()
	{
		screen.state = States.Coloring
		
		screen.toggleNext();

		screen.outroduce( 'helper', 'fadeOut' );
		screen.outroduce( 'completed', 'fadeOut', function()
		{			
			screen.introduce( 'colorPicker', 'fadeIn ~0.5s' );
			screen.introduce( 'coloring', 'flipInX' );
		});

		screen.body = ColorizeFactory( screen._bodyNoLabel );
		screen.bodySensor = ColorizeFactory( screen._bodySensor );

		screen.frontWheel = ColorizeFactory( screen._frontWheel );
		screen.backWheel = ColorizeFactory( screen._backWheel );
		screen.hiddenWheel = ColorizeFactory( screen._hiddenWheel );	
		
		$scope.bodyColor( UserProgress.CurrentBodyColorName() );
		$scope.wheelColor( UserProgress.CurrentWheelColorName() );
	};
	
	// Initialize the power it up screen
	screen.setPowerItUpState = function()
	{
		screen.state = States.PowerItUp;

		screen.toggleNext();

		screen.outroduce( 'colorPicker', 'fadeOut' );
		screen.outroduce( 'coloring', 'fadeOut', function()
		{
			screen.introduce( 'controllerGroup', 'fadeIn' );
			screen.introduce( 'assembled', 'flipInX' );
			screen.introduce( 'poweritup', 'fadeIn ~0.5s' );
		});
	};
	
	// Initialize the screen before the test screen
	screen.setTestPreviewState = function()
	{
		screen.state = States.TestPreview;

		screen.outroduce( 'next', 'nextOut' );
		screen.outroduce( 'poweritup', 'flipOutX', function()
		{
			screen.introduce( 'testRobot', 'slideInUpRight ~0.5s 2s' );
			screen.introduce( 'backgroundTest', 'fadeIn 2s' );
			screen.introduce( 'begin', 'slideInDownRight ~1s' );
			
			screen._bodyGroup.data( 'intro', 'bodyGroupTest' ).dataPlay( 'intro' );
		});
	};
	
	// Method invoked when user selects a color for the body.
	$scope.bodyColor = function(colorName)
	{
		screen.view.find( '.selectable.color.' + colorName ).play( 'rubberBand' );
		
		// Update user progress with selected body color
		UserProgress.BodyColor = UserProgress.GetBodyColor( colorName );

		var color = UserProgress.CurrentBodyColor();

		screen.body.setColor( UserProgress.Colors.Gray, color );
		screen.bodySensor.setColor( UserProgress.Colors.Gray, color );
	};
	
	// Method invoked when user selects a color for the wheels.
	$scope.wheelColor = function(colorName)
	{
		screen.view.find( '.selectable.color.' + colorName ).play( 'rubberBand' );
		
		// Update user progress with selected wheel color
		UserProgress.WheelColor = UserProgress.GetWheelColor( colorName );

		var color = UserProgress.CurrentWheelColor();

		screen.frontWheel.setColor( UserProgress.Colors.White, color );
		screen.backWheel.setColor( UserProgress.Colors.White, color );
		screen.hiddenWheel.setColor( UserProgress.Colors.White, color );
	};
	
	// The next screen is the test screen
	$scope.next = function()
	{
		if ( screen.state === States.Building )
		{
			screen.setColoringState();
		}
		else if ( screen.state === States.Coloring )
		{
			screen.setPowerItUpState();
		}
		else if ( screen.state === States.PowerItUp )
		{
			screen.setTestPreviewState();
		}
	};

	// Test!
	$scope.begin = function()
	{
			manager.transition('level2_test');	
	};
	
	// The previous screen is the plan screen
	$scope.prev = function()
	{
		manager.transition('level2_plan');
	};
	
}]);